import React, { Component } from 'react';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore';
import { observer } from 'mobx-react';
import ProjectSelect from '../Projects/ProjectSelect';

const ProjectChipBlock = observer(class ProjectChipBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
        };

        this.handleProjectClick = this.handleProjectClick.bind(this);
        this.handleProjectSelect = this.handleProjectSelect.bind(this);
        this.addParticipant = this.addParticipant.bind(this);
        this.load = this.load.bind(this);
        this.deleteParticipant = this.deleteParticipant.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        var token = localStorage.getItem("token");
        MainStore.setMaskVisible();
        var scope = this;
        fetch('api/Project/GetMyProjects', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ projects: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleProjectClick = project => () => {
        var projectIds = MainStore.getFilterProjectIds.slice();
        var index = projectIds.findIndex(p => p === project.id);
        if (index > -1) {
            projectIds.splice(index, 1);
            MainStore.setFilterProjectIds(projectIds);
            project = null;
        }
        else {
            projectIds.push(project.id);
            MainStore.setFilterProjectIds(projectIds);
        }

        this.props.onProjectSelect && this.props.onProjectSelect(projectIds);
    }

    handleProjectSelect(project) {
        if (!project || !project.id) {
            this.setState({ isProjectAdding: false });
        }
        else {
            this.addParticipant(project.id, localStorage.getItem('userId'));
        }
    }

    addParticipant(projectId, userId) {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/AddParticipant', {
            method: 'POST',
            body: JSON.stringify({ projectId: projectId, userId: userId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    if (result.isExists) {
                        alert("Участник уже добавлен");
                        return;
                    }
                    scope.setState({ isProjectAdding: false });
                    scope.load();
                }).catch((err) => console.log(err));
            }
        });
    }

    deleteParticipant(projectId, userId) {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/DeleteParticipant', {
            method: 'POST',
            body: JSON.stringify({ projectId: projectId, userId: userId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    if (result.isExists) {
                        alert("Участник уже добавлен");
                        return;
                    }
                    var projects = scope.state.projects.slice(0);
                    projects.splice(projects.findIndex(p => p.project.id === projectId), 1);
                    scope.setState({ projects: projects });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDelete = projectId => () => {
        this.deleteParticipant(projectId, localStorage.getItem('userId'));
    }

    render() {
        return (
            <div className={"project-chip-block clearfix " + this.props.className}>
                {this.state.projects.map(p => <Chip
                    size="small"
                    label={p.project.name}
                    avatar={<Avatar>{p.count}</Avatar>}
                    onClick={this.handleProjectClick(p.project)}
                    color={MainStore.getFilterProjectIds.findIndex(fp => fp === p.project.id) > -1 ? "secondary" : "primary"}
                    className="project-chip"
                    onDelete={this.handleDelete(p.project.id)}
                />)}
                {this.state.isProjectAdding && <ProjectSelect key="chip-block" handleSelect={this.handleProjectSelect}/>
                }
                <IconButton
                    className="add-participant-button"
                    onClick={() => { this.setState({ isProjectAdding: true }); }}
                    size="large">
                    <AddIcon />
                </IconButton>
            </div>
        );
    }
})

export default ProjectChipBlock;